.root {
  height: 100%;
  border-bottom: none;
  background: #fff;
}

.compactLabel {
  font-weight: 700;
  font-size: 14px;
  color: var(--mantine-color-dark-7);
}

.contextField {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.contextFieldLabel {
  font-size: 11px;
  font-weight: 600;
  color: var(--mantine-color-dimmed);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.contextWarning {
  font-size: 13px;
  color: var(--mantine-color-orange-7);
}
